<template>
  <el-dialog
    title="下单网点详情"
    :visible.sync="visible"
    :before-close="handleClose"
    width="1000px"
    top="30px"
  >
    <div class="dialog-body">
      <div class="module-control">
        <el-form
          ref="listQueryFormRef"
          inline
          :model="listQuery"
          label-width="80px"
          style="width: 100%"
        >
          <el-form-item label="起止时间" prop="code">
            <el-date-picker
              v-model="listQuery.timeRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="small"
              :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 360px"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="">
            <el-button
              type="primary"
              icon="Search"
              size="small"
              @click="onSearch"
            >
              查询
            </el-button>
            <el-button icon="Refresh" size="small" @click="onReset">
              重置
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="module-table">
        <el-table
          :data="dataList"
          border
          max-height="600"
          :header-cell-style="{ backgroundColor: '#ec9368', color: '#000' }"
        >
          <el-table-column
            prop="orgCode"
            label="网点编码"
            align="center"
            width="200"
          />
          <el-table-column prop="orgName" label="网点名称" align="center" />
          <el-table-column
            prop="totalNumber"
            label="总下单数量"
            align="center"
            width="200"
          />
        </el-table>
      </div>
      <div class="module-pagination">
        <el-pagination
          v-if="!!total"
          @size-change="
            (val) => {
              this.listQuery.size = val
              this.getList()
            }
          "
          @current-change="
            (val) => {
              this.listQuery.current = val
              this.getList()
            }
          "
          :current-page="listQuery.current"
          :page-sizes="[10, 20, 40, 60, 100]"
          :page-size="listQuery.size"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import * as ApiAnalysis from '@/api/analysis'

export default {
  name: 'DialogOrg',
  data() {
    return {
      visible: false,
      pageLoading: false,
      listQuery: {
        timeRange: [],
        startTime: null,
        endTime: null,
        current: 1,
        size: 100,
      },
      dataList: [],
      total: 0,
    }
  },
  methods: {
    getList() {
      this.pageLoading = true
      ApiAnalysis.getOrgList({
        ...this.listQuery,
        startTime: this.listQuery.timeRange?.[0],
        endTime: this.listQuery.timeRange?.[1],
      })
        .then((res) => {
          this.dataList.splice(0, this.dataList.length)
          this.dataList.push(...res.data.records)
          this.total = res.data.total || 0
        })
        .finally(() => {
          this.pageLoading = false
        })
    },

    onSearch() {
      this.listQuery.current = 1
      this.getList()
    },

    onReset() {
      this.$refs.listQueryFormRef.resetFields()
      this.listQuery.timeRange = []
      this.listQuery.startTime = null
      this.listQuery.endTime = null
      this.listQuery.current = 1
      this.getList()
    },

    handleShow(data) {
      this.visible = true
      this.listQuery.timeRange = data?.timeRange || []
      this.onSearch()
    },

    handleClose() {
      this.$refs.listQueryFormRef.resetFields()
      this.visible = false
    },
  },
}
</script>

<style scoped lang="scss">
.module-pagination {
  display: flex;
  justify-content: center;
  padding-top: 20px;
}
</style>
